import { useSelector } from "react-redux";

import { useRecentEventForCurrentMode } from "../../../../../hooks/useRecentEventForCurrentMode";
import { selectFocusedEvent } from "../../../../../store/slices/socket/selectors";
import type { RootState } from "../../../../../store/store";
import { ReleasePointVis } from "../../svg/ReleasePointVis";

interface Props {
  style?: React.CSSProperties;
}

export const ReleaseVis = ({ style }: Props) => {
  const { isViewingPreviousEvent } = useSelector(
    (state: RootState) => state.socket,
  );
  const focusedEvent = useSelector(selectFocusedEvent);
  const recentEvent = useRecentEventForCurrentMode();

  // Toggle data based on if we are viewing a previous event or current event
  const pitch_data = isViewingPreviousEvent
    ? focusedEvent.pitch_data
    : recentEvent.pitch_data;

  return (
    <ReleasePointVis
      style={
        style
          ? style
          : {
              width: "85%",
              marginTop: "60px",
              marginBottom: "40px",
              marginRight: "5%",
            }
      }
      relSide={pitch_data?.RelSideFeet}
      relHeight={pitch_data?.RelHeightFeet}
    />
  );
};
